import schema from './schema.js'

export default {
  title: '採購項目',
  schema,
  edit: {
    ui: {
      form: {
        name: 'formEditor',
        fields: [
          ['orderRef.key', 'orderRef.date', 'orderRef.sellerRef'],
          ['sku.key', 'name', 'qty', 'price', 'subtotal'],
          ['note'],
        ],
      },
    },
    // populations: 'purchaseOrders,skus,suppliers',
    // populationdepth: 2,
  },
  list: {
    ui: {
      fields: [
        { path: 'orderRef.key', model: 'purchaseReqs', queryPath: 'orderRef' },
        { path: 'orderRef.date', model: 'purchaseReqs', queryPath: 'orderRef' },
        {
          path: 'orderRef.status',
          model: 'purchaseReqs',
          queryPath: 'orderRef',
        },
        {
          path: 'orderRef.sellerRef',
          model: 'purchaseReqs',
          queryPath: 'orderRef',
        },
        'sku.key',
        'name',
        'qty',
        'unarrivedQty',
        'onTheWayQty',
        { path: 'price' },
        { path: 'subtotal' },
        'note',
      ],
    },
    populations: 'purchaseReqs,skus,suppliers',
    populationdepth: 2,
  },
}
